export default "__VITE_ASSET__3ca0234a__"